import { render } from "./ModalPromotionWarning.vue?vue&type=template&id=63f7af0c"
import script from "./ModalPromotionWarning.vue?vue&type=script&lang=js"
export * from "./ModalPromotionWarning.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__